import script from "./PlatformPoliciesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformPoliciesView.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformPoliciesView.vue?vue&type=style&index=0&id=10b6d82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b6d82c"]])

export default __exports__